import { compose } from 'recompose';
import gql from 'graphql-tag';
import { graphql } from 'graphql/utils';
import { get } from 'utils';

export const withData = () =>
    compose(
        graphql(
            gql`
                query withUploadedDocument($documentId: ID!) {
                    content(filter: { contentIds: [$documentId] }) {
                        __typename
                        id
                        title
                        contentType
                        createdDate
                        pdfProxy
                        ... on DocumentContent {
                            pdfUrl
                        }
                    }
                }
            `,
            {
                props: ({ data }) => {
                    const content = get(data, 'content[0]');
                    return {
                        // The API issues this URL signed with a media token for the current user (CORE-1893);
                        // the client no longer builds it or places an api key in it.
                        pdfUrl: get(content, 'pdfProxy', ''),
                        contentType: get(content, 'contentType'),
                        documentError: !!get(data, 'error'),
                        documentLoading: get(data, 'loading'),
                        publishedDate: get(content, 'createdDate'),
                        title: get(content, 'title')
                    };
                },
                options: ({ documentId, streamId }) => ({
                    fetchPolicy: 'cache-first',
                    returnPreviousData: true,
                    variables: {
                        documentId,
                        streamId,
                        includeHighlights: !!streamId
                    }
                })
            }
        )
    );
